import type { Type_IUnit, Type_IUnitList } from '../Type/Type.hive'
import { UA_readyFilterItems } from './UA.readyFilterItems'
import type { UA_AddUnitsData } from './UA.types'
import { Util_isDateInRange } from '../Util/Util.isDateInRange'
import type { AppUnitType } from '../../../shared/domain/units/types.no-deps'

export function UA_readyAddUnits(
    addUnitsData: UA_AddUnitsData,
    {
        unitListId,
        allUnitLists,
        allUnits,
        allUnitTypes,
    }: {
        unitListId: number
        allUnitLists: Type_IUnitList[]
        allUnits: Type_IUnit[]
        allUnitTypes: AppUnitType[]
    }
): UA_AddUnitsData {
    let newAddUnitsData = {
        ...addUnitsData,
        unitsLookup: new Map<number, Type_IUnit>(
            allUnits.map((unit: Type_IUnit): [number, Type_IUnit] => [unit.id, unit])
        ),
    }

    if (unitListId) {
        const unitList = allUnitLists.find((ul) => ul.id === unitListId)
        const unitsInList = new Set(
            unitList.units
                .filter(({ startDate, endDate }) => Util_isDateInRange(startDate, endDate))
                .map((unit) => unit.id)
        )

        // During the cycle of the sectionProducts we now have a validation to guaranty the unit
        // belong to the location list of units, we then need to filter the results for empty objects.
        const units = allUnits.filter((unit) => unitsInList.has(unit.id))

        newAddUnitsData = {
            ...newAddUnitsData,
            unitListIdToAddUnitTo: unitListId,
        }

        return UA_readyFilterItems(newAddUnitsData, units, allUnits, allUnitTypes)
    } else {
        // Only want to display units that match our target type for this action
        const units = allUnits.filter((unit) => unit.type === addUnitsData.targetUnitTypeId)

        return UA_readyFilterItems(newAddUnitsData, units, allUnits, allUnitTypes)
    }
}
